<h1 mat-dialog-title>{{ data.name }}</h1>
<div mat-dialog-content>
  <div [innerHTML]="data.content"></div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">
    {{ 'common.cancel' | transloco }}
  </button>
  <button mat-flat-button color="primary" (click)="dialogRef.close(true)">
    {{ 'common.confirm' | transloco }}
  </button>
</div>
